import { render, staticRenderFns } from "./FormShopping.vue?vue&type=template&id=04a240b0&scoped=true"
import script from "./FormShopping.vue?vue&type=script&lang=js"
export * from "./FormShopping.vue?vue&type=script&lang=js"
import style0 from "./FormShopping.vue?vue&type=style&index=0&id=04a240b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a240b0",
  null
  
)

export default component.exports